export default "__VITE_ASSET__952f756e__"